/**
 * MobileNav Component
 * Bottom navigation bar for mobile devices
 * Only visible on screens < 1024px
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Lightbulb, 
  Activity, 
  ClipboardList, 
  Users, 
  Map,
  Target
} from 'lucide-react';
import './MobileNav.css';

interface MobileNavProps {
  isVisible?: boolean;
}

const MobileNav: React.FC<MobileNavProps> = ({ isVisible = true }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const navItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', tourId: 'dashboard' },
    { path: '/insights', icon: Lightbulb, label: 'Insights', tourId: null },
    { path: '/decision-board', icon: Target, label: 'Board', tourId: null },
    { path: '/monitoring', icon: Activity, label: 'Monitor', tourId: 'monitoring' },
    { path: '/issues', icon: ClipboardList, label: 'Issues', tourId: 'issues' },
    { path: '/stakeholders', icon: Users, label: 'People', tourId: 'stakeholders' },
    { path: '/stakeholder-map', icon: Map, label: 'Map', tourId: null },
  ];

  return (
    <nav className={`mobile-nav ${!isVisible ? 'nav-hidden' : ''}`}>
      {navItems.map((item) => {
        const Icon = item.icon;
        const active = isActive(item.path);
        
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`mobile-nav-item ${active ? 'active' : ''}`}
            {...(item.tourId ? { 'data-mobile-tour': item.tourId } : {})}
          >
            <Icon size={20} className="mobile-nav-icon" />
            <span className="mobile-nav-label">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileNav;
